module.exports = __webpack_public_path__ + "img/電気回路_1_4_2.d3e77b09.png";